import React, { lazy } from 'react';
const TESTIMONIALS = [{
  name: 'Micaela R.',
  image: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774998704/T1_d6sipt.png',
  quote: 'Aprendí a tejer mi primera bikini en una semana. Las explicaciones son tan claras que ni necesité experiencia previa.'
}, {
  name: 'Sofía D.',
  image: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774998716/T2_xykcx7.png',
  quote: 'Hice dos modelos diferentes y ya los vendí en Instagram. Este ebook se paga solo cien veces.'
}, {
  name: 'Paula S.',
  image: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774998728/T3_wwly6a.jpg',
  quote: 'Nunca había tejido ropa. Con las tablas de medidas y los pasos visuales, mi primera pieza me quedó perfecta.'
}, {
  name: 'Valeria C.',
  image: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774998743/T4_eyas0a.png',
  quote: 'Encontré una nueva pasión. Tejer bikinis es terapéutico Y rentable.'
}, {
  name: 'Juliana G.',
  image: 'https://res.cloudinary.com/dqvi0nktw/image/upload/v1774998772/T5_fvcwtb.png',
  quote: 'Los detalles de terminación hacen toda la diferencia. Mis piezas se ven profesionales.'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-beige py-12 md:py-20 px-4" data-id="element-411">
      <div className="max-w-[720px] mx-auto" data-id="element-412">
        <p className="font-body text-xs uppercase tracking-widest text-medium-gray text-center mb-3" data-id="element-413">
          Compras verificadas · Resultados reales
        </p>
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray text-center mb-10" data-id="element-414">
          ⭐ Lo que dicen mujeres reales (más de 3.500)
        </h2>

        <div className="space-y-5" data-id="element-415">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white rounded-2xl shadow-md overflow-hidden border-l-4 border-pink-light" data-id="element-416">
              {/* Mobile: vertical layout */}
              <div className="lg:hidden" data-id="element-417">
                <div className="w-full aspect-square bg-pink-50" data-id="element-418">
                  <img src={t.image} alt={`Resultado de ${t.name}`} loading="lazy" decoding="async" className="w-full h-full object-cover object-center" draggable={false} data-id="element-419" />
                </div>
                <div className="p-5 pt-3" data-id="element-420">
                  <div className="text-amber-400 text-sm mb-2" aria-label="5 estrellas" data-id="element-421">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-body italic text-dark-gray mb-3 leading-relaxed" data-id="element-422">
                    "{t.quote}"
                  </p>
                  <p className="font-body font-bold text-sm text-dark-gray" data-id="element-423">
                    — {t.name} —{' '}
                    <span className="text-medium-gray font-normal" data-id="element-424">
                      Compradora Verificada ✅
                    </span>
                  </p>
                </div>
              </div>

              {/* Desktop: horizontal layout */}
              <div className="hidden lg:flex items-stretch" data-id="element-425">
                <div className="w-[110px] flex-shrink-0 aspect-square bg-pink-50" data-id="element-426">
                  <img src={t.image} alt={`Resultado de ${t.name}`} loading="lazy" decoding="async" className="w-full h-full object-cover object-center rounded-l-[14px]" draggable={false} data-id="element-427" />
                </div>
                <div className="p-5 pl-4 flex flex-col justify-center" data-id="element-428">
                  <div className="text-amber-400 text-sm mb-2" aria-label="5 estrellas" data-id="element-429">
                    ⭐⭐⭐⭐⭐
                  </div>
                  <p className="font-body italic text-dark-gray mb-3 leading-relaxed" data-id="element-430">
                    "{t.quote}"
                  </p>
                  <p className="font-body font-bold text-sm text-dark-gray" data-id="element-431">
                    — {t.name} —{' '}
                    <span className="text-medium-gray font-normal" data-id="element-432">
                      Compradora Verificada ✅
                    </span>
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="text-center mt-10 font-body" data-id="element-433">
          <p className="font-bold text-dark-gray text-base md:text-lg" data-id="element-434">
            📊 +3.500 mujeres ya descargaron esta guía.
          </p>
          <p className="font-bold text-dark-gray text-base md:text-lg" data-id="element-435">
            Muchas de ellas hoy venden lo que tejen.
          </p>
        </div>
      </div>
    </section>;
}